import React from 'react';

const Breadcrumbs = ({active, levels, parent, parentSlug}) => {

  return (
    <div id="breadcrumbs" className="breadcrumbsclass fs-9 fs-md-8 mt-3 lh-sm">
        <ul className="mb-0" itemScope itemType="https://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <a itemProp="item" href="/">
              <span className="fw-bold" itemProp="name">Casinos Vergleich</span>
              <meta itemProp="position" content="1" />
            </a>
          </li>
          <span className="mx-1" aria-label="and then">›</span>
          { levels === 3 ?
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <a itemProp="item" href={'https://casinos-vergleich.de/' + parentSlug}>
              <span className="fw-bold" itemProp="name">{parent}</span>
              <meta itemProp="position" content="2" />
            </a>
          </li>
          : null }
          { levels === 3 ?
          <span className="mx-1" aria-label="and then">›</span>
          : null }
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <span itemProp="name">{active}</span>
            <meta itemProp="position" content={levels} />
          </li>
        </ul>
      </div>
  );
}

export default Breadcrumbs;